import styled from "styled-components";

export const Container = styled.div`
background-color: #fff;
  box-shadow: 2px 4px 10px 1px rgba(0, 0, 0, 0.47);
  -webkit-box-shadow: 2px 4px 10px 1px rgba(0, 0, 0, 0.47);
  -moz-box-shadow: 2px 4px 10px 1pxrgba(235, 180, 180, 0.47);
  padding: 20px;
`;

export const Title = styled.h3`
font-size: 16px;
color: #4a4b4c;
margin-bottom: 15px;
`;
export const P = styled.p`
color: #8c9ea9;
font-size: 13px;
margin-bottom: 24px;
`;
export const Span = styled.span`
color: #33cdff;
`;
export const UserDeatils = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
export const UserImg = styled.img`
  width: 30px;
  height: 30px;
  object-fit: cover;
`;
export const Username = styled.p``;